<div class="d-flex justify-content-center mt-3">
<h2>Files for Download</h2>
</div>
<div *ngFor="let upload of uploads | async">
  <app-download-file  [upload]="upload"></app-download-file>
</div>
